import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import guides from "./GuidesFiles";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw"; // ✅ Allow raw HTML inside markdown
import { LanguageContext } from './LanguageContext';
import "./css/GuidesPage.css";

function GuidesPage() {
  const { guideId } = useParams();
  const guide = guides.find((g) => g.id === guideId);
  const [content, setContent] = useState("");
  const { language, translations } = useContext(LanguageContext);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const popupText = {
  en: {
    title: "Want the next part of this guide?",
    description:
      "I can show you exactly how I calculate whether using points is worth it or not.",
    placeholder: "Your best email",
    button: "Send me the next part",
    close: "Close",
  },
  pt: {
    title: "Quer a próxima parte desse guia?",
    description:
      "Posso te mostrar exatamente como eu calculo se vale a pena usar os pontos ou não. Se quiser continuar, é só deixar seu e-mail abaixo:",
    placeholder: "e-mail",
    button: "Enviar",
    close: "X",
  },
};

  useEffect(() => {
    if (guide) {
      fetch(guide.url[language])
        .then((res) => res.text())
        .then((text) => setContent(text))
        .catch(() => {});
    }
  }, [guide, language]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [guideId]);

  if (!guide) return <p>{translations.GuiaNãoEncontrado}</p>;

  const guideTitle = typeof guide.title === "object"
    ? (guide.title[language] || guide.title.en)
    : guide.title;


  const handleSubmit = async () => {
  if (!email) return;

  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (!isValid) return;

  setLoading(true);

  try {
  const res = await fetch(
    "https://api.convertkit.com/v3/forms/9469055/subscribe",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        api_key: process.env.REACT_APP_KIT_API_KEY,
        email: email,
      }),
    }
  );

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Subscribe failed");
  }

  setSubmitted(true);
  setEmail("");
} catch (err) {
} finally {
  setLoading(false);
}
};

  return (
    <div className="guide-page-wrapper">
      {/* Hero Header */}
      <div
        className="guide-hero"
        style={{ backgroundImage: `url(${guide.image})` }}
      >
        <div className="guide-hero-overlay">
          {/* Breadcrumbs */}
          <nav className="guide-breadcrumbs">
            <Link to="/">{language === "pt" ? "Início" : "Home"}</Link>
            <span className="breadcrumb-separator">›</span>
            <Link to="/blog-guides">{language === "pt" ? "Guias" : "Guides"}</Link>
            <span className="breadcrumb-separator">›</span>
            <span className="breadcrumb-current">{guideTitle.replace(/📘\s*/, '')}</span>
          </nav>

          {/* Hero Title */}
          <h1 className="guide-hero-title">{guideTitle.replace(/📘\s*/, '')}</h1>

          {/* Category Badge */}
          {guide.category && (
            <span className="guide-category-badge">
              {translations[`categories.${guide.category}`] || guide.category}
            </span>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="guide-page">
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {content}
        </ReactMarkdown>

        {guideId === "hyatt-card" && (
          <div className="guide-cta">
            {submitted ? (
              <p className="guide-cta-thanks">
                {language === "pt"
                  ? "Obrigada! Em breve você receberá a próxima parte no seu e-mail."
                  : "Thanks! You'll receive the next part in your inbox soon."}
              </p>
            ) : (
              <>
                <h2 className="guide-cta-title">{popupText[language].title}</h2>
                <p className="guide-cta-description">{popupText[language].description}</p>
                <div className="guide-cta-form">
                  <input
                    type="email"
                    className="guide-cta-input"
                    placeholder={popupText[language].placeholder}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    className="guide-cta-button"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Sending..." : popupText[language].button}
                  </button>
                </div>
              </>
            )}
          </div>
        )}

        {/* Back to Guides */}
        <div className="guide-back-nav">
          <Link to="/blog-guides" className="back-to-guides-btn">
            ← {language === "pt" ? "Voltar aos Guias" : "Back to Guides"}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default GuidesPage;
